export default __webpack_public_path__ + "static/media/hero-img1.76fa0e58.jpg";